import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import emailjs from '@emailjs/browser'
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'
import './contact.css'

emailjs.init("S229Yq-pv37cz6Zb1");

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    businessName: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    try {
      const result = await emailjs.send(
        'block_automation_service',  // Get this from EmailJS dashboard
        'template_rpvvyff', // Get this from EmailJS dashboard
        formData,
        'S229Yq-pv37cz6Zb1'   // Get this from EmailJS dashboard
      )

      if (result.text === 'OK') {
        alert('Message sent successfully!')
        // Clear form
        setFormData({
          name: '',
          email: '',
          businessName: '',
          message: ''
        })
      } else {
        alert('Failed to send message. Please try again.')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('An error occurred. Please try again later.')
    }
  }

  return (
    <div className="contact-container">
      <Helmet>
        <title>Contact - block automation</title>
        <meta property="og:title" content="Contact - block automation" />
        <meta property="og:description" content="block better." />
      </Helmet>
      <NavBar />
      
      {/* Contact Form Section */}
      <div className="contact-form-container section-container">
        <div className="max-width">
          <div className="contact-content">
            <h1 className="contact-title">Get in Touch</h1>
            <p className="contact-description">
              Fill out the form below and we'll get back to you within 48 hours.
            </p>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Business Name</label>
                <input 
                  type="text" 
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  placeholder="Your business name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your needs" 
                  required
                ></textarea>
              </div>
              <button type="submit" className="button button-primary">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Contact 